import { useMutation } from '@apollo/client'
import { UPDATE_OPTION } from 'queries/option'
import { useErrMsgControl } from 'hooks'
import { EResCode } from 'utils/other'

const useOptionMutation = () => {
  const [updateOption, optionUpdate] = useMutation(UPDATE_OPTION, { context: { clientName: 'endpointAdmin' } })
  const isLoading = optionUpdate.loading

  const errMsg = () => {
    // optionUpdate
    if (
      optionUpdate?.error ||
      (optionUpdate.data?.updateProductOptionGroup?.res_code &&
        optionUpdate.data?.updateProductOptionGroup?.res_code !== EResCode.Success)
    )
      return JSON.stringify(optionUpdate?.error || optionUpdate.data?.updateProductOptionGroup?.res_desc)
  }

  useErrMsgControl(errMsg())

  return { updateOption, isLoading }
}

export default useOptionMutation
